module.exports = __webpack_public_path__ + "img/bingo_ball-5.26f4ee0c.png";